import { RegisterFinishedComponent } from '@/pages/register-finished/register-finished.component';
import { AnalyzeComponent } from './home/analyze/analyze.component';
import { HelpComponent } from './home/help/help.component';
import { SettingsComponent } from './home/settings/settings.component';
import { TilesComponent } from './home/tiles/tiles.component';
import { DashboardComponent } from './home/dashboard/dashboard.component';
import { AddonsComponent } from '@/home/settings/addons/addons.component';
import { StoreComponent } from '@/home/settings/store/store.component';
import { LogoutComponent } from '@/pages/logout/logout.component';
import { ActivationComponent } from '@/pages/activation/activation.component';
import { NewPasswordComponent } from '@/pages/new-password/new-password.component';
import { ProfileComponent } from './home/profile/profile.component';
import { LostPasswordComponent } from '@/pages/lost-password/lost-password.component';
import { RegisterComponent } from '@/pages/register/register.component';
import { AppNotfoundComponent } from './common/app.notfound.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppAccessdeniedComponent } from './common/app.accessdenied.component';
import { AppErrorComponent } from './common/app.error.component';
import { LoginComponent } from '@/pages/login/login.component';
import { AuthGuard } from '@/core/services/auth-guard.service';
import { OnboardingComponent } from './home/onboarding/onboarding.component';
import { TeamDashboardComponent } from '@/home/team-dashboard/team-dashboard.component';
import { WebConsoleComponent } from '@/home/web-console.component';
import { AuthPageComponent } from '@/pages/auth-page.component';
import { GeneralComponent } from '@/home/settings/general/general.component';
import { SettingsAppsComponent } from '@/home/apps/settings-apps.component';
import { LayerComponent } from '@/home/settings/layer/layer.component';
import { IntegrationsComponent } from '@/home/settings/integrations/integrations.component';
import { ApiKeyComponent } from '@/home/settings/api-key/api-key.component';
import { ShareComponent } from '@/home/share/share.component';

const routes: Routes = [
    {
        path: '',
        component: WebConsoleComponent,
        canActivate: [AuthGuard],
        children: [
            { path: '', component: DashboardComponent, data: { breadcrumb: 'Dashboard' } },
            { path: 'dashboard', redirectTo: '', pathMatch: 'full' },
            { path: 'analyze/:state', component: AnalyzeComponent },
            { path: 'layer/:id', component: TilesComponent },
            { path: 'activities', redirectTo: 'analyze/detail', data: { breadcrumb: 'Dashboard' } },
            { path: 'onboarding', component: OnboardingComponent, data: { breadcrumbKey: 'nav_onboarding' } },
            { path: 'team', component: TeamDashboardComponent, data: { breadcrumbKey: 'nav_user' } },
            { path: 'store', redirectTo: '/settings/store', pathMatch: 'full' },
            { path: 'addons', redirectTo: '/settings/addons', pathMatch: 'full' },
            {
                path: 'settings',
                component: SettingsComponent,
                data: { breadcrumbKey: 'nav_settings', menuKey: 'settings' },
                children: [
                    { path: '', redirectTo: 'general', pathMatch: 'full' },
                    { path: 'general', component: GeneralComponent },
                    { path: 'layer', component: LayerComponent },
                    { path: 'integrations', component: IntegrationsComponent },
                    { path: 'integrations/:integration', component: IntegrationsComponent },
                    { path: 'api', component: ApiKeyComponent },
                    { path: 'addons', component: AddonsComponent },
                    { path: 'store', component: StoreComponent },
                    { path: 'apps', redirectTo: '/apps', pathMatch: 'full' },
                    { path: 'share', redirectTo: '/share', pathMatch: 'full' },
                ],
            },
            { path: 'profile', component: ProfileComponent, data: { breadcrumbKey: 'profile_myprofile' } },
            { path: 'apps', component: SettingsAppsComponent, data: { breadcrumbKey: 'apps_page_heading' } },
            { path: 'share', component: ShareComponent, data: { breadcrumbKey: 'share_page_heading' } },
            { path: 'help', component: HelpComponent, data: { breadcrumbKey: 'help_support_heading' } },
        ],
    },
    {
        path: 'wizard',
        loadChildren: () => import('@/start-wizard/start-wizard.module').then((m) => m.StartWizardModule),
    },
    {
        path: '',
        component: AuthPageComponent,
        children: [
            { path: 'activation/:token', component: ActivationComponent },
            { path: 'new-password/:token', component: NewPasswordComponent },
            { path: 'login', component: LoginComponent },
            { path: 'logout', component: LogoutComponent },
            { path: 'register', component: RegisterComponent },
            { path: 'register-finished', component: RegisterFinishedComponent },
            { path: 'lost-password', component: LostPasswordComponent },
        ],
    },

    { path: 'error', component: AppErrorComponent },
    { path: 'access', component: AppAccessdeniedComponent },
    { path: 'notfound', component: AppNotfoundComponent },
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full',
    },
    { path: '**', redirectTo: '/notfound' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
